import { Box } from "../../../components/elements"
import { Fieldset, Input, Label, validations } from "../../../components/form"

import { useFormContext } from "react-hook-form"
import styled from "styled-components"
import { IContactValues } from "../types"

const NameInputs = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  width: 100%;
  gap: clamp(0.5rem, 0.4rem + 0.5vw, 1rem);
  align-items: center;
  flex-wrap: wrap;
`

const Container = styled(Box)`
  gap: clamp(1rem, 0.8rem + 1vw, 2rem);
  margin-block: 2.5rem;
`

const ContactFields = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<IContactValues>()

  return (
    <Container fullwidth flexDirection="column">
      <Fieldset>
        <Label required>貴社名</Label>
        <Input
          error={errors.company}
          placeholder="会社名をご入力ください"
          registration={register(`company`, validations.requiredText)}
          type="text"
        />
      </Fieldset>

      <Fieldset>
        <Label required>ご担当者名</Label>
        <NameInputs>
          <Input
            placeholder="姓"
            error={errors.lastname}
            registration={register(`lastname`, validations.requiredText)}
            type="text"
          />
          <Input
            error={errors.firstname}
            placeholder="名"
            type="text"
            registration={register(`firstname`, {
              required: "入力してください",
            })}
          />
        </NameInputs>
      </Fieldset>

      <Fieldset>
        <Label required>勤務先メールアドレス</Label>
        <Input
          error={errors.email}
          placeholder="例) example@josys.com"
          registration={register(`email`, {
            ...validations.requiredText,
            ...validations.emailPattern,
          })}
          type="text"
        />
      </Fieldset>

      <Fieldset>
        <Label required>電話番号</Label>
        <Input
          error={errors.phone}
          placeholder="例) 03-xxxx-xxxx"
          registration={register(`phone`, validations.requiredText)}
          type="tel"
        />
      </Fieldset>
    </Container>
  )
}

export { ContactFields, type IContactValues }
